var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createMuiTheme, responsiveFontSizes, } from "@material-ui/core/styles";
var scrollBar = {
    track: "#2b2b2b",
    thumb: "#6b6b6b",
    active: "#959595",
};
var darkScrollbar = function (options) {
    if (options === void 0) { options = scrollBar; }
    return {
        scrollbarColor: "".concat(options.thumb, " ").concat(options.track),
        "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
            backgroundColor: options.track,
        },
        "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
            borderRadius: 8,
            backgroundColor: options.thumb,
            minHeight: 24,
            border: "3px solid ".concat(options.track),
        },
        "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
            backgroundColor: options.active,
        },
        "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
            backgroundColor: options.active,
        },
        "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
            backgroundColor: options.active,
        },
        "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
            backgroundColor: options.track,
        },
    };
};
export var createDarkTheme = function (options) {
    var theme = createMuiTheme(__assign(__assign({}, options), { palette: __assign(__assign({}, options.palette), { type: "dark", background: {
                paper: "#424242",
                default: "#303030",
            }, primary: {
                light: "#62cdff",
                main: "#009ce2",
                dark: "#006eb0",
                contrastText: "#000",
            }, secondary: {
                light: "#ff59bc",
                main: "#e7018c",
                dark: "#af005f",
                contrastText: "#000",
            }, error: {
                light: "#e57373",
                main: "#f44336",
                dark: "#d32f2f",
                contrastText: "#fff",
            } }), overrides: {
            MuiCssBaseline: {
                "@global": {
                    body: darkScrollbar(),
                },
            },
        } }));
    return responsiveFontSizes(theme);
};
